window.addEventListener('DOMContentLoaded', () => {
  const productInformations = document.querySelectorAll(".product-information-list-item");

function openProductInformation(element) {
  document.body.style.overflow = "clip";
  element.classList.add("open");
}

function closeProductInformation(element) {
  document.body.style.overflow = "";
  element.classList.remove("open");
}

productInformations.forEach(productInformation => {
  const informationTitle = productInformation.querySelector(".product-information-list-item__title");
  const blockIndex = productInformation.dataset.blockIndex;

  const informationModal = document.querySelector(`.product-information-list-item__content-wrapper[data-block-index="${blockIndex}"]`);
  const closeInformation = informationModal.querySelector(".product-information-list-item__content-close-wrapper");

  informationTitle.addEventListener('click', () => {
    openProductInformation(informationModal);
  });
  informationModal.addEventListener('click', (event) => {
    if (event.target != informationModal.querySelector(".product-information-list-item__content")) {
      closeProductInformation(informationModal);
    }
  });
  closeInformation.addEventListener('click', () => {
    closeProductInformation(informationModal);
  });
});
});
